import React from 'react';
import { getIn, useFormikContext } from 'formik';

import CanvasTheorySection from './CanvasTheorySection';

const CanvasTheorySectionContainer = (props: any) => {
  const { values, setFieldValue } = useFormikContext<any>();

  const handleAddClick = () => {
    setFieldValue('withCanvasTheory', true);
  };

  const handleRemoveClick = (event: any) => {
    event.stopPropagation();

    setFieldValue('withCanvasTheory', false);
    setFieldValue('canvasTheory', []);
  };

  const withCanvasTheory = getIn(values, 'withCanvasTheory');

  return (
    <CanvasTheorySection
      {...props}
      withCanvasTheory={withCanvasTheory}
      onAddClick={handleAddClick}
      onRemoveClick={handleRemoveClick}
    />
  );
};

export default React.memo(CanvasTheorySectionContainer) as any;
